import React, { useEffect, useState } from "react";
import { CaretUp, CaretDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

// Option 4 — compact horizontal progress-bar stat tile.
export const GovBarStat = ({ testid, label, value, hint, icon: Icon, fill = 0, delta, onClick }) => {
  const target = Math.max(0, Math.min(1, fill));
  const [draw, setDraw] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setDraw(target), 60);
    return () => clearTimeout(t);
  }, [target]);

  const DeltaIcon = delta?.dir === "down" ? CaretDown : CaretUp;
  const deltaColor = delta?.dir === "down" ? "#f87171" : delta?.dir === "up" ? "#34d399" : "hsl(var(--muted-foreground))";

  const body = (
    <>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5 min-w-0">
          {Icon ? (
            <span className="grid place-items-center h-7 w-7 rounded-lg shrink-0 bg-primary/10 border border-primary/30">
              <Icon size={15} weight="duotone" className="text-primary" />
            </span>
          ) : null}
          <span className="text-[10px] uppercase tracking-[0.18em] mono text-muted-foreground truncate">{label}</span>
        </div>
        {delta ? (
          <span className="inline-flex items-center gap-0.5 text-[10px] mono shrink-0 tabnum" style={{ color: deltaColor }}>
            {delta.dir !== "neutral" ? <DeltaIcon size={10} weight="fill" /> : null}
            {delta.text}
          </span>
        ) : null}
      </div>

      <div className="flex items-baseline gap-2 mt-1.5">
        <span className="font-heading text-[17px] md:text-[19px] tabnum text-[#22d3ee] text-glow-cyan leading-none break-all">{value}</span>
        {hint ? <span className="text-[10px] mono text-muted-foreground/80 truncate">{hint}</span> : null}
      </div>

      <div className="relative h-1.5 rounded-full bg-white/[0.07] overflow-hidden mt-2.5">
        <div
          className="absolute inset-y-0 left-0 rounded-full"
          style={{ width: `${draw * 100}%`, background: "linear-gradient(90deg,#9D5CFF,#22d3ee)", transition: "width 0.9s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </div>
    </>
  );

  const base = "relative overflow-hidden rounded-2xl border border-primary/25 bg-card/50 backdrop-blur-md box-glow p-4 flex flex-col text-left w-full";
  if (onClick) {
    return (
      <button type="button" data-testid={testid} onClick={onClick} className={cn(base, "transition-colors hover:border-[#22d3ee]/50")}>
        {body}
      </button>
    );
  }
  return <div data-testid={testid} className={base}>{body}</div>;
};
